"use client";

import React, { useEffect, useState } from "react";
import styles from "../css/mainMemberMedicalAidPopup.module.css";
import { usePopup } from "../context/PopupContext";
import { listPractitioners } from "../../../../api/profile/create_profile";

const MainMemberMedicalAidPopup = ({ onClose, overlay = false, data }) => {
  const { openPopup } = usePopup();
  const [notes, setNotes] = useState(data?.main?.note || "");
  const [practitionerName, setPractitionerName] = useState("");
  const [practiceNumber, setPracticeNumber] = useState("");

  const main = data?.main || {};
  const mm = data?.mainmember || {};

  useEffect(() => {
    let cancelled = false;
    async function resolvePractitioner() {
      const pid = mm.practitionerid;
      if (!pid) return;
      try {
        const docs = await listPractitioners();
        if (cancelled || !Array.isArray(docs)) return;
        const match = docs.find((d) => Number(d.id) === Number(pid));
        if (match) {
          setPractitionerName(match.label || "");
          setPracticeNumber(match.practicenumber || "");
        }
      } catch (_) {
      }
    }
    resolvePractitioner();
    return () => {
      cancelled = true;
    };
  }, [mm.practitionerid]);

  const handleNext = () => {
    openPopup("beneficiaries", { mergedProfile: data });
  };

  const content = (
    <div className={styles.popup}>
        <div className={styles.header}>
          <h2>Main Member Medical Aid Details</h2>
          <button className={styles.closeButton} onClick={onClose}>
            ×
          </button>
        </div>
        <div className={styles.content}>
          <div className={styles.section}>
            <label>Medical Aid Provider</label>
            <input type="text" value={mm.medicalaidprovider || ""} readOnly />
          </div>
          <div className={styles.section}>
            <label>Medical Aid Number</label>
            <input type="text" value={mm.medicalaidnumber || ""} readOnly />
          </div>
          <div className={styles.section}>
            <label>Practitioner</label>
            <input type="text" value={practitionerName} readOnly />
          </div>
          <div className={styles.section}>
            <label>Practice Number</label>
            <input type="text" value={practiceNumber} readOnly />
          </div>
          <div className={styles.section}>
            <label>Dependant Code</label>
            <input type="text" value={main.dependentcode || ""} readOnly />
          </div>
          <div className={styles.section}>
            <label>Note</label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Add notes here..."
              rows={4}
            />
          </div>
        </div>
        <button className={styles.nextButton} onClick={handleNext}>
          Next
        </button>
      </div>
  );

  if (overlay) {
    return <div className={styles.overlay}>{content}</div>;
  }
  return content;
};

export default MainMemberMedicalAidPopup;

